/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/render/specialHandler/skirtingBoard.js
 * @Author: Yongchao Wang
 * @Date: 2021-07-24 14:08:00
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-03-14 14:29:28
 */

import { MeshBuilder } from '@babylonjs/core/Meshes/meshBuilder';
import { Texture } from '@babylonjs/core/Materials/Textures/texture';
import { PBRMaterial } from '@babylonjs/core/Materials/PBR/pbrMaterial';
import { Vector3 } from '@babylonjs/core/Maths/math';

class SkirtingBoard {
  /**
   * @description: 初始化台面
   * @param {*} scene 场景
   * @param {*} position 中心点位置
   * @param {*} size 长宽高
   * @return {*}
   * @author: Yongchao Wang
   */

   shadowInfo:{
    width:number,
    lengthType:string,
    type:string
   }

   constructor(scene, position, size) {
     this.scene = scene;
     this.position = position;
     this.size = size;
     this.mesh = null;
   }

   createSkirtingBoard(textureImage) {
     if (this.mesh) {
       this.mesh.dispose();
       this.scene.removeMesh(this.mesh);
       this.mesh = null;
     }
     const box = MeshBuilder.CreateBox('SkirtingBoard', this.size, this.scene);
     this.mesh = box;
     box.position = new Vector3(this.position.x, this.position.y, this.position.z);
     box.material = this.getMaterial(textureImage);
   }

   getMaterial(textureImage) {
     if (!this.mesh) {
       return undefined;
     }
     let myMaterial = this.mesh.material;
     if (myMaterial === null) {
       myMaterial = new PBRMaterial('myMaterial', this.scene);
       myMaterial.metallic = 0;
       myMaterial.roughness = 0.8;
       myMaterial.environmentIntensity = 0.4;
     }
     const texture = new Texture(textureImage, this.scene, undefined, undefined, undefined, () => {
       const abstractMesh = this.mesh.getHierarchyBoundingVectors();
       const bounds = abstractMesh.max.subtract(abstractMesh.min);
       texture.vScale = 1;
       texture.uScale = 0.6 / bounds.x;
       myMaterial.albedoTexture = texture;
     });

     return myMaterial;
   }

   changeTexture(textureImage) {
     const myMaterial = this.getMaterial(textureImage);
     this.mesh.material = myMaterial;
   }

   setHideLength(length) {
     this.hide = length;
   }
}

export default SkirtingBoard;
